export const SET_LOGIN_ERROR_MESSAGE = 'login-form/set-login-error-message';

export const SET_SHOW_PASSWORD = 'login-form/set-show-password';

export const RESET_LOGIN_FORM_STATE = 'login-form/reset-login-form-state';

export const SET_RESET_ERROR_MESSAGE = 'login-form/reset-reset-error-message';
